import styles from './index.sass';

const LoadingIndicator = ({ className = '', progress = null, progressRenderer = null, size = 25 }) => {
	const hasProgress = progress !== null && progress !== undefined;

	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 110 110'
			className={`${styles.loadingIndicator} ${!hasProgress ? styles.shouldRotate : ''} ${className}`}
			style={{ width: `${size}px`, height: `${size}px` }}
		>
			<circle
				cx='55'
				cy='55'
				r='50'
				strokeWidth={progress === false ? '0' : '10'}
				strokeLinecap='round'
				stroke='currentColor'
				strokeDasharray={hasProgress ? `0 0 ${(progress || 0) * 314}px 1000px` : null}
				fill='none'
			/>
			{progressRenderer instanceof Function && (
				<text x='55' y='55' dominantBaseline='middle' textAnchor='middle' style={{ fontSize: '60px', fill: 'white' }}>
					{progressRenderer(progress)}
				</text>
			)}
		</svg>
	);
};
export default LoadingIndicator;
